export default {"src":"/_next/static/media/mastercard-gray.3a28b321.svg","height":21,"width":34,"blurWidth":0,"blurHeight":0};